import React from 'react'
import Card from '../../../components/ui/Card'
import Button from '../../../components/ui/Button'
import Icon from '../../../components/AppIcon'

// Auth v2: buy values are shown plainly — the operator at the counter needs
// them (the old MaskedValue only unmasked for the retired finance role).
const formatUsd = (value) => {
  const num = Number(value)
  if (value == null || value === '' || isNaN(num)) return '-'
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

const CalculationResults = ({ calculations, onGenerateQuote, quoteActive }) => {

  const formatWeight = (value) => {
    if (!value && value !== 0) return '—'
    return `${value.toFixed(2)}g`
  }

  const formatKarat = (item) => {
    if (item.metal === 'silver') return 'Silver'
    return `${item.karatWhole}.${item.karatDecimal}K`
  }

  if (!calculations || calculations.items.length === 0) {
    return (
      <Card variant="solid" padding="none" className="rounded-xl border-[#DCDFE5] bg-white shadow-none">
        <div className="border-b border-[#DCDFE5] px-5 py-4">
          <h3 className="text-sm font-semibold text-[#17191D]">Calculation</h3>
        </div>
        <div className="px-5 py-6">
          <p className="text-sm text-[#656C78]">Payout</p>
          <p className="mt-2 text-4xl font-semibold leading-none text-[#17191D]">—</p>
          <div className="mt-6 flex items-start gap-2 border-t border-[#DCDFE5] pt-4">
            <Icon name="Calculator" size={16} className="mt-0.5 shrink-0 text-[#656C78]" />
            <p className="text-sm leading-5 text-[#656C78]">Enter item weights to see calculation</p>
          </div>
        </div>
      </Card>
    )
  }

  return (
    <Card variant="solid" padding="none" className="rounded-xl border-[#DCDFE5] bg-white shadow-none">
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-[#DCDFE5] px-5 py-4">
        <h3 className="text-sm font-semibold text-[#17191D]">Calculation</h3>
        {quoteActive && (
          <span className="flex items-center gap-1.5 text-xs font-medium text-[#2457DB]">
            <Icon name="LockKeyhole" size={12} />
            Quote Active
          </span>
        )}
      </div>

      <div className="px-5 py-5">
        <p className="text-sm text-[#656C78]">Payout</p>
        <p className="mt-2 break-words text-[clamp(1.75rem,2.5vw,2.5rem)] font-semibold leading-tight tracking-tight text-[#17191D] tabular-nums">
          {formatUsd(calculations.totalNet)}
        </p>
      </div>

      {/* Item breakdown */}
      <div className="mx-5 space-y-3 border-t border-[#DCDFE5] py-4">
        {calculations.items.map((item, idx) => (
          <div key={item.id} className="flex items-start justify-between gap-3 text-sm">
            <span className="min-w-0 break-words leading-5 text-[#656C78]">
              {idx + 1}. {formatKarat(item)} {item.itemType} ({item.weight}g)
            </span>
            {/* Deságio is internal-only (admin reports) — this panel faces the
                customer at the counter, so items show the net offer, period. */}
            <span className="shrink-0 text-right font-medium text-[#17191D] tabular-nums">
              {formatUsd(item.netValue)}
            </span>
          </div>
        ))}
      </div>

      {/* Totals */}
      <div className="mx-5 space-y-2.5 border-t border-[#DCDFE5] py-4">
        <div className="flex justify-between gap-3 text-sm">
          <span className="text-[#656C78]">Total Weight</span>
          <span className="shrink-0 font-medium text-[#17191D] tabular-nums">{formatWeight(calculations.totalWeight)}</span>
        </div>
        <div className="flex justify-between gap-3 text-sm">
          <span className="text-[#656C78]">Pure Weight (24K equiv.)</span>
          <span className="shrink-0 font-medium text-[#17191D] tabular-nums">{formatWeight(calculations.totalPureWeight)}</span>
        </div>
      </div>

      {/* Generate Quote Button */}
      {!quoteActive && (
        <div className="px-5 pb-5">
          <Button
            variant="outline"
            className="w-full border-[#DCDFE5] bg-white text-[#17191D] hover:bg-[#F5F6F8]"
            onClick={onGenerateQuote}
            iconName="Clock"
            iconPosition="left"
          >
            Lock Price (15 min)
          </Button>
        </div>
      )}
    </Card>
  )
}

export default CalculationResults
